import { createBrowserRouter, Navigate } from "react-router-dom";
import LoginPage from "../auth/LoginPage";
import Dashboard from "../pages/superAdmin/Dashboard";
import SuperAdminLayout from "../components/layouts/SuperAdminLayout";
import ManageAdmins from "../pages/superAdmin/ManageAdmins";
import ControllerDetails from "../pages/superAdmin/ControllerDetails";
import AdminLayout from "../components/layouts/AdminLayout";
import AdminDashboard from "../pages/admin/AdminDashboard";
import AdminController from "../pages/admin/AdminController";
import AdminControllerDetails from "../pages/admin/AdminControllerDetails";
import SubControllerDetails from "../pages/sub_branch/SubControllerDetails";
import HeadMyBranches from "../pages/head_office/HeadMyBranches";
import HeadBranchLayout from "../components/layouts/HeadBranchLayout";
import HeadControllerDetails from "../pages/head_office/HeadControllerDetails";
import HeadDashboard from "../pages/common/HeadDashboard";
import BurnerReport from "../pages/reports/BurnerReport";
import HeadManageDeliveryBoy from "../pages/head_office/HeadManageDeliveryBoy";
import ManageHeadOffice from "../pages/common/ManageHeadOffice";
import ManageBranch from "../pages/admin/ManageBranch";
import DeliveryBoyDeleteUrl from "../pages/deleteUrl/DeliveryBoyDeleteUrl";
import UpdateController from "../pages/admin/UpdateController";
import CylinderWeightReport from "../pages/reports/CylinderWeightReport";
import ManageCylinderType from "../pages/superAdmin/ManageCylinderType";
import ManageParameters from "../pages/admin/ManageParameters";
import ConfigureGLD from "../pages/admin/ConfigureGLD";
import AdminGLDLog from "../pages/admin/AdminGLDLog";
import SubGLDLog from "../pages/sub_branch/SubGLDLog";
import GLDLogs from "../pages/superAdmin/GLDLogs";
import HeadGLDLogs from "../pages/head_office/HeadGLDLogs";
import EmptyingReport from "../pages/reports/EmptyingReport";
import OfflineReport from "../pages/reports/OfflineReport";
import OffTimeReport from "../pages/reports/OffTimeReport";
import PressureGraphView from "../pages/reports/PressureGraphView";
import HeadBypassReport from "../pages/head_office/HeadBypassReport";
import HeadOfflineReport from "../pages/head_office/HeadOfflineReport";
import HeadEmptyingReport from "../pages/head_office/HeadEmptyingReport";

export const routes = createBrowserRouter([
  { path: "/sign_in", element: <LoginPage /> },

  // super admin routes
  { path: "/", element: <Navigate to={"/1"} /> },
  {
    path: "/:page_nmr",
    element: (
      <SuperAdminLayout>
        <Dashboard />
      </SuperAdminLayout>
    ),
  },
  {
    path: "/manage_admins/:page_nmr2",
    element: (
      <SuperAdminLayout>
        <ManageAdmins />
      </SuperAdminLayout>
    ),
  },
  {
    path: "/manage_head_office",
    element: (
      <SuperAdminLayout>
        <ManageHeadOffice />
      </SuperAdminLayout>
    ),
  },
  {
    path: "/manage_cylinder_type",
    element: (
      <SuperAdminLayout>
        <ManageCylinderType />
      </SuperAdminLayout>
    ),
  },
  {
    path: "/controller_details",
    element: <ControllerDetails />,
  },
  {
    path: "/controller_details/burner_report/:branch_id",
    element: <BurnerReport />,
  },
  {
    path: "/controller_details/cylinder_weight_report/:branch_id",
    element: <CylinderWeightReport />,
  },
  {
    path: "/controller_details/emptying_report/:subbranch_id",
    element: <EmptyingReport />,
  },
  {
    path: "/controller_details/offline_report/:branch_id",
    element: <OfflineReport />,
  },
  {
    path: "/controller_details/offtime_report/:branch_id",
    element: <OffTimeReport />,
  },
  {
    path: "/controller_details/graph_view/:branch_id",
    element: <PressureGraphView />,
  },
  {
    path: "/controller_details/gld_logs",
    element: <GLDLogs />,
  },

  // admin routes
  {
    path: "/admin/admin_dashboard",
    element: (
      <AdminLayout>
        <AdminDashboard />
      </AdminLayout>
    ),
  },
  {
    path: "/admin/admin_controller/:page_nmr",
    element: (
      <AdminLayout>
        <AdminController />
      </AdminLayout>
    ),
  },
  {
    path: "/admin/manage_my_branch",
    element: (
      <AdminLayout>
        <ManageBranch />
      </AdminLayout>
    ),
  },
  {
    path: "/admin/admin_controller_details",
    element: <AdminControllerDetails />,
  },
  {
    path: "/admin/update_controller",
    element: <UpdateController />,
  },
  {
    path: "/admin/manage_parameters",
    element: <ManageParameters />,
  },
  {
    path: "/admin/gld_configuration",
    element: <ConfigureGLD />,
  },
  {
    path: "admin/gld_logs",
    element: <AdminGLDLog />,
  },
  {
    path: "/admin/manage_headoffice",
    element: (
      <AdminLayout>
        <ManageHeadOffice />
      </AdminLayout>
    ),
  },
  {
    path: "/admin/dashboard",
    element: (
      <AdminLayout>
        <HeadDashboard />
      </AdminLayout>
    ),
  },

  // head office routes
  {
    path: "/head_office/dashboard",
    element: (
      <HeadBranchLayout>
        <HeadDashboard />
      </HeadBranchLayout>
    ),
  },
  {
    path: "/head_office/my_branches",
    element: (
      <HeadBranchLayout>
        <HeadMyBranches />
      </HeadBranchLayout>
    ),
  },
  {
    path: "/head_office/controller_details",
    element: <HeadControllerDetails />,
  },
  {
    path: "/head_office/manage_delivery_boy",
    element: (
      <HeadBranchLayout>
        <HeadManageDeliveryBoy />
      </HeadBranchLayout>
    ),
  },
  {
    path: "/head_office/controller_details/gld_logs",
    element: <HeadGLDLogs />,
  },
  {
    path: "/head_office/bypass_report",
    element: (
      <HeadBranchLayout>
        <HeadBypassReport />
      </HeadBranchLayout>
    ),
  },
  {
    path: "/head_office/offline_report",
    element: (
      <HeadBranchLayout>
        <HeadOfflineReport />
      </HeadBranchLayout>
    ),
  },
  {
    path: "/head_office/emptying_report",
    element: (
      <HeadBranchLayout>
        <HeadEmptyingReport />
      </HeadBranchLayout>
    ),
  },

  // sub branch routes
  // {
  //   path: "/sub_branch/dashboard",
  //   element: (
  //     <SubBranchLayout>
  //       <SubDashboard />
  //     </SubBranchLayout>
  //   ),
  // },
  {
    path: "/sub_branch/controller_details",
    element: <SubControllerDetails />,
  },
  {
    path: "/sub_branch/controller_details/gld_logs",
    element: <SubGLDLog />,
  },

  // delivery boy delete url
  { path: "/delivery_boy_deletion", element: <DeliveryBoyDeleteUrl /> },
]);
